module.exports = __webpack_public_path__ + "media/images/icons/amenities-bb97cd675fd711601542855cff017592.svg";